<template>
  <div class="basic_zhlanguage height_fill" :style="langsImgStyle" v-if="$store.state.myRender.common.setting.zhLanguageOpen">
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <a :href="$store.state.myRender.common.setting.zhLanguageAdress" class="a_contain" :data-num="module.data.pc_widgets_infor.height">
      <img :title="listArr.note" :src="imgSrc">
    </a>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_zhlanguage',
  data() {
    return {
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    imgSrc() {
      let src = `https://sitecdn.71360.com/static/txys-001/image/zh_lang/${this.module.data.listArr.module_style}.png`
      if(this.$store.state.app.view_pattern === 'mb') {
        src = `https://sitecdn.71360.com/static/txys-001/image/zh_lang/mb_${this.module.data.listArr.module_style}.png`
      }
      return src
    },
    langsImgStyle() {
      let style = {}
      if(this.$store.state.app.view_pattern === 'mb') {
        let num = this.$store.state.myRender.common.setting.loginRegister ? 60: 20; // 这个是为了 右侧放置登录注册头部的东西
        style = {
          left: this.$store.state.myRender.common.mb_header_nav_position == 'left' ? 'auto' : `${num}px`,
          right: this.$store.state.myRender.common.mb_header_nav_position == 'left' ? `${num}px` : 'auto',
        }
      } else {
        style = { height: this.module.data.pc_widgets_infor.height  + 'px'}
      }
      return style
    },
    listArr () {
      return this.module.data.listArr;
    },
    view_pattern () {
      return this.$store.state.app.view_pattern;
    }
  },
  watch: {
  },
  methods: {
  },
  created() {
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped type="text/css">
.basic_zhlanguage {
  height: 100%;
}
.a_contain {
  height: 100%;
  display: flex;
  align-items: center;
}
.mobile_header .basic_zhlanguage {
  position: absolute;
  width: 30px;
  top: 28px;
  transform: translate(0, -50%);
  z-index: 1999;
  right: 60px;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_zhlanguage/index.vue